import { Alert, Layout, Menu, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
// import Footer from '../components/Footer/Footer';
import { EditOutlined, InboxOutlined, SettingOutlined, ShareAltOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import './style.css';

const RootLayout = ({ children, innerClass = '', activeForm, showNavbar = true }) => {
  return (
    <Layout className={innerClass}>
      {showNavbar && <Navbar activeForm={activeForm} />}
      <Layout.Content>{children}</Layout.Content>
      {/* <Footer /> */}
    </Layout>
  );
};

export const FormLayout = ({ children, innerClass = '', activeForm }) => {
  const { t } = useTranslation();
  const drawerContent = (
    <Menu className="form-builder-drawer-menu">
      <Menu.Item key="edit">
        <NavLink to={`/forms/${activeForm.id}/build`}>
          {' '}
          <EditOutlined />
          <Typography.Text>{t('card.edit')}</Typography.Text>
        </NavLink>
      </Menu.Item>
      <Menu.Item key="share">
        <NavLink to={`/forms/${activeForm.id}/share`}>
          <ShareAltOutlined />
          <Typography.Text>{t('card.share')}</Typography.Text>
        </NavLink>
      </Menu.Item>

      <Menu.Item key="responses">
        <NavLink to={`/forms/${activeForm.id}/responses`}>
          <InboxOutlined />
          <Typography.Text>{t('card.responses')} </Typography.Text>
        </NavLink>
      </Menu.Item>

      <Menu.Item key="settings">
        <NavLink to={`/forms/${activeForm.id}/settings`}>
          <SettingOutlined />
          <Typography.Text>{t('settings')}</Typography.Text>
        </NavLink>
      </Menu.Item>
    </Menu>
  );
  return (
    <Layout className={innerClass}>
      <Navbar activeForm={activeForm} drawerTitle="Jump to" drawerContent={drawerContent} />
      <Layout.Content>{children}</Layout.Content>
      {/* <Footer /> */}
    </Layout>
  );
};

export const NetworkStatusOverlay = () => {
  const { t } = useTranslation();
  return (
    <div className="network-status-overlay">
      <div className="network-status-message">
        <Alert type="error" message={t('networkStatus.message')} />
      </div>
    </div>
  );
};

export default RootLayout;
